import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './invoices.css';

// Print icon component
const PrintIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/>
  </svg>
);

const SalesInvoice = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { invoice } = location.state || {};

  if (!invoice) {
    return (
      <div className="container tables bg-white mt-5">
        <div className="alert alert-danger">No invoice data found</div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ar-SA', {
      style: 'currency',
      currency: 'SAR'
    }).format(amount);
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="container tables bg-white mt-5">
      <div className="tableTitle d-flex justify-content-between">
        <h3>{t('invoices.salesInvoice')}</h3>
        <div className="d-flex gap-2">
          <button className="btn btn-primary" onClick={handlePrint}>
            <PrintIcon />
            <span className="pe-3">{t('invoices.print')}</span>
          </button>
          <button className="btn btn-secondary" onClick={() => navigate('/Invoices')}>
            {t('invoices.cancel')}
          </button>
        </div>
      </div>

      <div className="invoice-container">
        {/* Header */}
        <div className="invoice-header">
          <div className="row">
            <div className="col-6">
              <h2 className="company-name">اسم الشركة</h2>
              <p>العنوان: المملكة العربية السعودية</p>
              <p>الهاتف: +966-XX-XXXXXXX</p>
              <p>البريد الإلكتروني: info@company.com</p>
            </div>
            <div className="col-6 text-end">
              <h3 className="invoice-title">فاتورة مبيعات</h3>
              <p><strong>رقم الفاتورة:</strong> {invoice.invoice_number}</p>
              <p><strong>التاريخ:</strong> {formatDate(invoice.invoice_date)}</p>
            </div>
          </div>
        </div>

        {/* Customer Information */}
        <div className="invoice-customer">
          <div className="row">
            <div className="col-6">
              <h4>بيانات العميل</h4>
              <p><strong>الاسم:</strong> {invoice.customer_name}</p>
              <p><strong>رقم الهوية:</strong> {invoice.customer_id}</p>
              <p><strong>الهاتف:</strong> {invoice.customer_phone}</p>
              <p><strong>العنوان:</strong> {invoice.customer_address}</p>
            </div>
            <div className="col-6 text-end">
              <h4>بيانات الدفع</h4>
              <p><strong>طريقة الدفع:</strong> {t(`invoices.${invoice.payment_method}`)}</p>
              <p><strong>تاريخ الدفع:</strong> {formatDate(invoice.invoice_date)}</p>
            </div>
          </div>
        </div>

        {/* Items Table */}
        <div className="invoice-items">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>{t('invoices.itemName')}</th>
                <th>{t('invoices.quantity')}</th>
                <th>{t('invoices.unitPrice')}</th>
                <th>{t('invoices.total')}</th>
              </tr>
            </thead>
            <tbody>
              {invoice.items && invoice.items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>{formatCurrency(item.unit_price)}</td>
                  <td>{formatCurrency(item.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Totals */}
        <div className="invoice-totals">
          <div className="row">
            <div className="col-6">
              {invoice.notes && (
                <div className="invoice-notes">
                  <h5>ملاحظات:</h5>
                  <p>{invoice.notes}</p>
                </div>
              )}
            </div>
            <div className="col-6">
              <div className="totals-table">
                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <td><strong>{t('invoices.subtotal')}:</strong></td>
                      <td className="text-end">{formatCurrency(invoice.subtotal)}</td>
                    </tr>
                    <tr>
                      <td><strong>{t('invoices.vat')}:</strong></td>
                      <td className="text-end">{formatCurrency(invoice.vat)}</td>
                    </tr>
                    <tr className="grand-total">
                      <td><strong>{t('invoices.grandTotal')}:</strong></td>
                      <td className="text-end"><strong>{formatCurrency(invoice.grand_total)}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="invoice-footer">
          <div className="row">
            <div className="col-12 text-center">
              <p>شكراً لتعاملكم معنا</p>
              <p>هذه الفاتورة صالحة لمدة 30 يوماً من تاريخ الإصدار</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesInvoice;
